var widget_default = {
  "card": "tY6LU",
  "link": "VPHBe",
  "container": "L9UCy",
  "image": "nYvOK",
  "right": "_5q9jV",
  "cardLayout": "CITqn",
  "content": "k6P-0",
  "title": "_7f1v5",
  "subtitle": "qgtVv",
  "button": "LhkCr",
  "button_disabled": "bdHm7",
  "buttonText": "h-EfA",
  "slimLayout": "_5KuzY",
  "rtl": "A47Hf",
  "ltr": "YogpW"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget.scss.js.map
